import { Component, Input } from '@angular/core';

@Component({
  selector: 'vee-dialog-heading',
  templateUrl: './dialog-heading.component.html',
  standalone: false,
})
export class DialogHeadingComponent {
  @Input() text = '';
}
